import { Component, ElementRef, ViewChild, inject, signal } from '@angular/core';
import { SidebarService } from '../../service/sidebar.service';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { hugeCancel01, hugeMenu01, hugeMoreVertical, hugeLogout01 } from '@ng-icons/huge-icons';
import { UserComponent } from '../../components/header/user/user.component';
import { AuthService } from '../../../features/auth/application/service';
import { ConfirmDialogService } from '../../service/confirm-dialog.service';
import { firstValueFrom } from 'rxjs';

@Component({
  standalone: true,
  selector: 'app-header',
  imports: [CommonModule, RouterModule, NgIcon, UserComponent],
  providers: [provideIcons({ hugeCancel01, hugeMenu01, hugeMoreVertical, hugeLogout01 })],
  templateUrl: './app-header.component.html',
})
export class AppHeaderComponent {
  private authService = inject(AuthService);
  private router = inject(Router);
  private readonly confirmDialogService = inject(ConfirmDialogService);

  isLoggingOut = signal(false);
  readonly isMobileOpen$;

  @ViewChild('searchInput') searchInput!: ElementRef<HTMLInputElement>;

  constructor(public sidebarService: SidebarService) {
    this.isMobileOpen$ = this.sidebarService.isMobileOpen$;
  }

  handleToggle() {
    if (window.innerWidth >= 1280) {
      this.sidebarService.toggleExpanded();
    } else {
      this.sidebarService.toggleMobileOpen();
    }
  }

  async logout() {
    if (this.isLoggingOut()) {
      return;
    }

    await this.confirmDialogService.confirm(
      'AUTH.LOGOUT.CONFIRM.TITLE',
      'AUTH.LOGOUT.CONFIRM.MESSAGE',
      undefined,
      undefined,
      undefined,
      async () => {
        if (this.isLoggingOut()) {
          return;
        }

        this.isLoggingOut.set(true);

        try {
          await firstValueFrom(this.authService.logout());
        } catch {
        } finally {
          this.afterLogout();
        }
      },
    );
  }

  private afterLogout() {
    this.isLoggingOut.set(false);
    this.router.navigate(['/auth/sign-in']);

    setTimeout(() => {
      window.location.reload();
    }, 500);
  }

  ngAfterViewInit() {
    document.addEventListener('keydown', this.handleKeyDown);
  }

  ngOnDestroy() {
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  handleKeyDown = (event: KeyboardEvent) => {
    if ((event.metaKey || event.ctrlKey) && event.key === 'k') {
      event.preventDefault();
      this.searchInput?.nativeElement.focus();
    }
  };
}
